import { render, staticRenderFns } from "./SupplierOrderRecordPanel.vue?vue&type=template&id=23ff7891&scoped=true"
import script from "./SupplierOrderRecordPanel.vue?vue&type=script&lang=js"
export * from "./SupplierOrderRecordPanel.vue?vue&type=script&lang=js"
import style0 from "./SupplierOrderRecordPanel.vue?vue&type=style&index=0&id=23ff7891&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff7891",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ff7891')) {
      api.createRecord('23ff7891', component.options)
    } else {
      api.reload('23ff7891', component.options)
    }
    module.hot.accept("./SupplierOrderRecordPanel.vue?vue&type=template&id=23ff7891&scoped=true", function () {
      api.rerender('23ff7891', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrderDetail/SupplierOrderRecordPanel.vue"
export default component.exports